import React from "react";
import classes from "./index.module.scss";

export function Footer() {
  return (
    <footer className={classes.footer}>
      <p>
        Bản quyền thuộc về công ty TNHH BHNT Prudential Việt Nam. Tất cả các
        quyền được bảo hộ.
      </p>
    </footer>
  );
}
